module.exports = __webpack_public_path__ + "static/media/ITAM-BNB.bcc577ca.svg";